import { TQueryKey } from 'core-components/types'
import { IFetchResult } from 'src/core/classes/helpers/store/Interfaces'
import { filterData } from 'src/core/types/helpers/filterData'
import { sortData } from 'src/core/types/helpers/sortData'
import { splitPagingData } from 'src/core/types/helpers/splitPagingData'
import Logger from 'src/core/utils/Logger'

export const updateQueries = <T>({
  queries,
  availableData,
  hierarchyField,
}: {
  queries: { [key: string]: IFetchResult<T> }
  availableData: T[]
  hierarchyField?: string
}) => {
  const queriesKeys = Object.keys(queries)
  for (const curQuery of queriesKeys) {
    try {
      const [filter, sort, paging]: TQueryKey = JSON.parse(curQuery)
      const filteredData = filterData(filter, queries[curQuery].items, availableData)
      const resortedData = sortData(filteredData, sort)
      const dataByPaging = splitPagingData(resortedData, paging)
      queries[curQuery].items = dataByPaging
      queries[curQuery].total = dataByPaging.length

      if (hierarchyField) {
        //Split new query items to groups
        queries[curQuery].groups = queries[curQuery].groups
          ?.map((el) => {
            //Getting first element for check existing group and determine the value of the field by which the group is built
            const firstElement = el[0]
            if (!firstElement) {
              //Group not exist
              return []
            }
            //Determine the value of the field by which the group is built
            const hierarchyFieldValue = firstElement[hierarchyField]
            //Filling group with new query items
            return dataByPaging.filter((el) => el[hierarchyField] === hierarchyFieldValue)
          })
          .filter((el) => el.length)
      }
    } catch (e) {
      Logger.error(`Bad query ${e}`)
    }
  }
}
